// First Created - 09 Aug 2026
// Author - Atul Pandey
// Purpose - RTK Query API slice for Session Q&A reporting
// Updated - 09 Aug 2026 - added Session Q&A PowerPoint report download
// Updated - 12 Aug 2026 - added Session Q&A Pdf report download

import {
    apiSlice,
} from '@/app/api/apiSlice'


export const sessionQNAReportsApiSlice =
apiSlice.injectEndpoints({
    endpoints:
        builder => ({


            /*
            |--------------------------------------------------------------------------
            | 01 - Get Session Q&A Report
            |--------------------------------------------------------------------------
            */

            getSessionQNAReport:
                builder.query({
                    query: ({
                        orgId,
                        trailId,
                        sessionId,
                        cohortId,
                    }) => ({
                        url:
                            '/reports/sessionQNAs',

                        params: {
                            orgId,
                            trailId,
                            sessionId,
                            cohortId,
                        },

                        validateStatus:
                            (
                                response,
                                result
                            ) => {
                                return (
                                    response.status ===
                                        200 &&
                                    !result
                                        ?.isError
                                )
                            },
                    }),

                    keepUnusedDataFor:
                        60,
                }),


            /*
            |--------------------------------------------------------------------------
            | 02 - Download Session Q&A PowerPoint
            |--------------------------------------------------------------------------
            */

            downloadSessionQNAPowerPoint:
                builder.mutation({
                    query: ({
                        orgId,
                        trailId,
                        sessionId,
                        cohortId,
                    }) => ({
                        url:
                            '/reports/sessionQNAs/powerpoint',

                        method:
                            'GET',

                        params: {
                            orgId,
                            trailId,
                            sessionId,
                            cohortId,
                        },

                        responseHandler:
                            async (
                                response
                            ) => {
                                return await response
                                    .blob()
                            },

                        cache:
                            'no-cache',
                    }),
                }),

            /*
            |--------------------------------------------------------------------------
            | 03 - Download Session Q&A PDF - 12 Aug 2026
            |--------------------------------------------------------------------------
            */

            downloadSessionQNAPdf:
                builder.mutation({
                    query: ({
                        orgId,
                        trailId,
                        sessionId,
                        cohortId,
                    }) => ({
                        url:
                            '/reports/sessionQNAs/pdf',

                        method:
                            'GET',

                        params: {
                            orgId,
                            trailId,
                            sessionId,
                            cohortId,
                        },

                        responseHandler:
                            async (
                                response
                            ) => {
                                return await response
                                    .blob()
                            },

                        cache:
                            'no-cache',
                    }),
                }),
            
            /*
            |--------------------------------------------------------------------------
            | 04 - Email Session Q&A Inline Report - 12 Aug 2026
            |--------------------------------------------------------------------------
            */

            emailSessionQNAInline:
                builder.mutation({
                    query: ({
                        orgId,
                        trailId,
                        sessionId,
                        cohortId,
                    }) => ({
                        url:
                            '/reports/sessionQNAs/email/inline',

                        method:
                            'POST',

                        body: {
                            orgId,
                            trailId,
                            sessionId,
                            cohortId,
                        },
                    }),
                }),


            /*
            |--------------------------------------------------------------------------
            | 05 - Email Session Q&A PDF Report - 12 Aug 2026
            |--------------------------------------------------------------------------
            */

            emailSessionQNAPdf:
                builder.mutation({
                    query: ({
                        orgId,
                        trailId,
                        sessionId,
                        cohortId,
                    }) => ({
                        url:
                            '/reports/sessionQNAs/email/pdf',

                        method:
                            'POST',

                        body: {
                            orgId,
                            trailId,
                            sessionId,
                            cohortId,
                        },
                    }),
                }),


            /*
            |--------------------------------------------------------------------------
            | 06 - Email Session Q&A PowerPoint Report - 12 Aug 2026
            |--------------------------------------------------------------------------
            */

            emailSessionQNAPowerPoint:
                builder.mutation({
                    query: ({
                        orgId,
                        trailId,
                        sessionId,
                        cohortId,
                    }) => ({
                        url:
                            '/reports/sessionQNAs/email/powerpoint',

                        method:
                            'POST',

                        body: {
                            orgId,
                            trailId,
                            sessionId,
                            cohortId,
                        },
                    }),
                }),
        }),
})


export const {
    useGetSessionQNAReportQuery,
    useLazyGetSessionQNAReportQuery,

    useDownloadSessionQNAPowerPointMutation,
    
    // 12 Aug 2026
    useDownloadSessionQNAPdfMutation,           

    // 12 Aug 2026
    useEmailSessionQNAInlineMutation,
    useEmailSessionQNAPdfMutation,
    useEmailSessionQNAPowerPointMutation,
} =
    sessionQNAReportsApiSlice